import React from "react";
import ContentBox from "../../../ContentBox/ContentBox";
import { StyledListView } from "../../../styles";
import { ValidationProps } from "../../types";

import { ListViewItem } from "@ingka/list-view";
import person from "@ingka/ssr-icon/paths/person";
import people from "@ingka/ssr-icon/paths/people";
import visiblityShow from "@ingka/ssr-icon/paths/visibility-show";

interface SelectRoleLayoutProps extends ValidationProps {
	activeStep: number;
}

const Layout: React.FC<SelectRoleLayoutProps> = ({ value, handleChange, activeStep }) => {
	const ref = React.useRef<HTMLLIElement>(null);

	React.useEffect(() => {
		if (activeStep === 2 && ref?.current) {
			ref.current.querySelector("input")?.focus();
		}
	}, [activeStep]);

	return (
		<ContentBox>
			<div>
				<StyledListView id={"roles-list"}>
					<ListViewItem
						id="role-admin"
						key="role-admin"
						title="Admin"
						emphasised
						description="Users with this role will have access to all markets and full control of the application."
						control="checkbox"
						controlProps={
							{
								value: "admin",
								checked: true,
								disabled: true,
							} as any
						}
						leadingIcon={person}
					/>
					<ListViewItem
						id="role-maintainer"
						key="role-maintainer"
						title="Maintainer"
						emphasised
						description="Users with this role have access to specific markets."
						control="checkbox"
						controlProps={
							{
								value: "role-maintainer",
								checked: true,
								disabled: true,
							} as any
						}
						leadingIcon={people}
					/>
					<ListViewItem
						id="role-read-only"
						key="role-read-only"
						title="Read only"
						emphasised
						description="Users with this role will have read only access to all markets."
						control="checkbox"
						showDivider={false}
						ref={ref}
						controlProps={
							{
								value: "role-read-only",
								checked: value.allowReadOnly,
							} as any
						}
						onChange={() => handleChange("", "allowReadOnly")}
						leadingIcon={visiblityShow}
					/>
				</StyledListView>
			</div>
		</ContentBox>
	);
};

export default Layout;
